export default "__VITE_ASSET__f4898f54__"